import React, { ReactNode, useEffect, useState } from "react";
import { ConvertionRatesStoreProvider } from "../../stores/ConvertionRatesStore/useConvertionRatesStore";
import { CopyNotifProvider } from "../../stores/CopyNotifStore/CopyNotifStore";
import { NotificationsStoreProvider } from "../../stores/NotificationsStore/NotificationsStore";
import { TonClientStoreProvider } from "../../stores/TonClientStore/useTonClientStore";
import { WalletStoreProvider } from "../../stores/WalletStore/useWalletStore";
import CopyNotifications from "../CopyNotif/CopyNotifications";
import { MainFooter } from "../MainFooter";
import { MainHeader } from "../MainHeader";
import Modals from "../Modals/Modals";
// import { ModalsStoreProvider } from "../Modals/useModalsStore";
import { useTonConnectUI } from "@tonconnect/ui-react";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useLocation } from "react-router-dom";
import { UserCartStoreProvider } from "../../features/UserCart/helpers/useUserCartStore";
import {
  MainHeaderStoreProvicer,
  useMainHeaderStore,
} from "../MainHeader/helpers/useMainHeaderStore";
import { CartContent } from "../MainHeader/ui/components/Cart/components/CartContent/CartContent";
import NotificationItems from "../Notification/NotificationItems";
import { PlaceARaffleProvider } from "../PlaceARaffle/usePlaceARaffleStore";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import s from "./Layouts.module.scss";

interface LayoutProps {
  children: ReactNode;
}

export const DefaultLayout: React.FC<LayoutProps> = observer(({ children }) => {
  //  const mainHeaderStore = useStore(MainHeaderStore, []);
  const mainHeaderStore = useMainHeaderStore();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <div className={clsx(location.pathname !== "/" && s.wrapper)}>
      <CartContent mainHeaderStore={mainHeaderStore} />
      <MainHeader
        mainHeaderStore={mainHeaderStore}
        mainPage={!isScrolled && location.pathname === "/"}
        isScrolled={isScrolled}
      />
      <ScrollToTop />
      <div>{children}</div>
      <MainFooter />
    </div>
  );
});

export const ProvidersLayout: React.FC<LayoutProps> = observer(
  ({ children }) => {
    const [_, setOptions] = useTonConnectUI();

    setOptions({
      actionsConfiguration: {
        modals: [],
        notifications: ["before", "success", "error"],
        returnStrategy: "back",
      },
    });
    // const dialogStore = useMemo(() => new DialogStore(), []);
    // const newDialogStore = useMemo(() => new NewDialogStore(), []);

    return (
      <MainHeaderStoreProvicer>
        <TonClientStoreProvider>
          <WalletStoreProvider>
            <NotificationsStoreProvider>
              <ConvertionRatesStoreProvider>
                <UserCartStoreProvider>
                  <PlaceARaffleProvider>
                    {/* <NftStakingStoreProvider>
                <NewDialogStoreProvider dialogStore={newDialogStore}>
                  <UnstakeStoreProvider>
                    <ClaimAndRestakeStoreProvider> */}
                    {/* <AddStakeStoreProvider>
                        <ClaimStoreProvider>
                          <DialogStoreProvider store={dialogStore}> */}
                    <Modals />

                    <CopyNotifProvider>
                      {children}
                      <CopyNotifications />
                      <NotificationItems />
                    </CopyNotifProvider>
                    {/* </DialogStoreProvider>
                        </ClaimStoreProvider>
                      </AddStakeStoreProvider>
                    </ClaimAndRestakeStoreProvider>
                  </UnstakeStoreProvider>
                </NewDialogStoreProvider>
              </NftStakingStoreProvider> */}
                  </PlaceARaffleProvider>
                </UserCartStoreProvider>
              </ConvertionRatesStoreProvider>
            </NotificationsStoreProvider>
          </WalletStoreProvider>
        </TonClientStoreProvider>
      </MainHeaderStoreProvicer>
    );
  }
);
